import React from 'react';

const NoMatches = () => (
  <div className="vendor-matches-table__tbody vendor-matches-table__spin">
    No matches found
  </div>
);

export default NoMatches;
